export default "images/asu.png";